<template xmlns="http://www.w3.org/1999/html">
  <div :class="`course-form-control ${error ? 'course-form-control--error' : ''}`">
    <label v-show="label">{{ label }}</label>
    <textarea :value="value"
           :name="name"
            :rows="rows || 3"
           :id="id"
           v-bind="$attrs"
           @blur="$emit('blur', $event.target.value)"
           @input="$emit('input', $event.target.value)"
           @change="$emit('change', $event.target.value)"
    ></textarea>
    <span class="text-error" v-if="error">
      {{ error }}
    </span>
  </div>
</template>


<script>
export default {
  props: ['value', 'error', 'label',  'id', 'name', 'rows'],
  emits: ['update:modelValue'],
}
</script>